var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSideBarOpenCloseLog = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#3EAE54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03665 11.0021L12.7776 7.26098C12.8806 7.15821 12.9373 7.02081 12.9373 6.87431C12.9373 6.72772 12.8806 6.59041 12.7776 6.48748L12.4498 6.15984C12.347 6.05675 12.2095 6 12.063 6C11.9165 6 11.7792 6.05675 11.6762 6.15984L7.22201 10.614C7.11868 10.7172 7.0621 10.8552 7.0625 11.0019C7.0621 11.1492 7.1186 11.287 7.22201 11.3903L11.6721 15.8402C11.775 15.9433 11.9123 16 12.0589 16C12.2054 16 12.3427 15.9433 12.4458 15.8402L12.7735 15.5125C12.9867 15.2993 12.9867 14.9521 12.7735 14.7389L9.03665 11.0021Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSideBarOpenCloseLog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SideBarOpenCloseLog.6ccf8a596213e74a29c5837ad5aaa5a1.svg";